export default __webpack_public_path__ + "static/media/number-shine-4.29892c93.svg";